import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import LiveTranslationsIndex from './index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/live-translations'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'live_translations_index',
          component: LiveTranslationsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
